/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Input, Table, Modal, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import SubscribeProgress from './subscribeProgress'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			selectedConstituent: null,
			isExporting: false,
			exportProgress: null
		}
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore, visible, onCancel, filterValue } = this.props
		const { barangay_uid, user_uid } = AuthStore
		const { 
			page, pageSize, sortOrder, sortName, searchText,
			isExporting, exportProgress
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<Modal
				title={`${filterValue}`}
				footer={null}
				visible={visible}
				onCancel={onCancel}
				destroyOnClose
				width='90%'
			>
				<Row>
					<Row>
						<Input style={{ width: 300, float: 'right', marginBottom: 20 }} placeholder='Search Here..' onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}} />
						<button 
							type="button" 
							className="btn btn-outline-success btn-rounded waves-effect waves-light"
							onClick={() => {
								const { exportHouseholds } = this.props
								const params = {
									filterValue,
									searchText
								}
								exportHouseholds(params)
							}}
						>
							<i className='mdi mdi-file-excel'/> Export in Excel
						</button>
					</Row>
					<Row>
						<Query 
							query={HOUSEHOLDS} 
							variables={{ 
								searchFilter: filters, 
								barangay_uid, 
								filterValue
							}}
							fetchPolicy='network-only'
						>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let households = _.has(data,'householdListByStatus') ? data.householdListByStatus.data : []
								households = households.map((household, key) => Object.assign({}, household, { key }))
								let _pagination = _.has(data, 'householdListByStatus') ? data.householdListByStatus.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								let columns = [
									{
									 	title: 'Household No.',
									 	dataIndex: 'household_no',
									 	key: 'household_no',
									 	width: 150
									}, {
										title: 'Member Count',
										dataIndex: 'member_count',
										key: 'member_count',
										width: 150
									}, {
										title: 'Head of Household',
										key: 'head_first_name',
										render: (record) => (
											<span>{record.head_first_name} {record.head_last_name}</span>
										)
									}, {
										title: 'Purok',
										dataIndex: 'purok_name',
										key: 'purok_name'
									}, {
										title: 'House No.',
										dataIndex: 'house_no',
										key: 'house_no'
									}, {
										title: 'Street',
										dataIndex: 'street',
										key: 'street'
									}, {
										title: 'Address',
										dataIndex: 'address',
										key: 'address'
									}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: 'household-status' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={households} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
												rowClassName={(record, index) => (record.is_alive == 0) ? 'table-row-deceased' :  ''}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Row>
			</Modal>
		)
	}
}

const HOUSEHOLDS = gql`
    query householdListByStatus($barangay_uid: String, $filterValue: String, $searchFilter: SearchParams) {
		householdListByStatus(barangay_uid: $barangay_uid, filterValue: $filterValue, searchFilter: $searchFilter)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const EXPORT_HOUSEHOLD_BY_STATUS = gql`
    mutation exportHouseholdsByStatus($input: JSON) {
		exportHouseholdsByStatus(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_HOUSEHOLD_BY_STATUS, {
		props({ mutate }) {
			return {
				exportHouseholds(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
